import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getPortalDomain } from 'packages/store/platform/platform.selectors';
import useDirectAccessToken from 'packages/hooks/useDirectAccessToken';
import AssetSourceService from 'packages/services/assetSource/AssetSourceService';
import { isErr } from 'packages/services/graphql/utils';
import { fixThumbnailUrls } from './utils';

export const useGetCollectionById = () => {
    const portalDomain = useSelector(getPortalDomain);
    const directAccessToken = useDirectAccessToken();

    const fetchCollectionById = useCallback(
        async (collectionId: number) => {
            const res = await AssetSourceService.fetchCollection(
                portalDomain,
                () => Promise.resolve(directAccessToken),
                collectionId,
            );

            if (isErr(res)) {
                return null;
            }

            return fixThumbnailUrls(res.value.node, portalDomain);
        },
        [directAccessToken, portalDomain],
    );

    return { fetchCollectionById };
};
